import { render, staticRenderFns } from "./Geo.vue?vue&type=template&id=4800a319&scoped=true&"
import script from "./Geo.vue?vue&type=script&lang=js&"
export * from "./Geo.vue?vue&type=script&lang=js&"
import style0 from "./Geo.vue?vue&type=style&index=0&id=4800a319&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4800a319",
  null
  
)

export default component.exports